// Inline SVG data URI for The Mill wordmark — used when no team logo_url is set
const DEFAULT_LOGO_URL =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 96' fill='none'%3E%3Cpath d='M74 18C106 4 144 4 172 18C188 26 201 38 208 54' stroke='%231a1a1a' stroke-width='8' stroke-linecap='round'/%3E%3Cpath d='M74 78C106 92 144 92 172 78C188 70 201 58 208 42' stroke='%231a1a1a' stroke-width='8' stroke-linecap='round'/%3E%3Ctext x='42' y='42' font-family='Inter,Arial,sans-serif' font-size='24' font-weight='700' letter-spacing='4' fill='%231a1a1a'%3ETHE%3C/text%3E%3Ctext x='18' y='76' font-family='Inter,Arial,sans-serif' font-size='52' font-weight='900' letter-spacing='2' fill='%231a1a1a'%3EMILL%3C/text%3E%3C/svg%3E";

export function resolveHeaderLogoUrl(teamLogoUrl: string | null | undefined): string {
  const env = (import.meta.env.VITE_HEADER_LOGO_URL as string | undefined)?.trim();
  if (env) return env;

  const team = teamLogoUrl?.trim();
  if (team && (team.startsWith('http://') || team.startsWith('https://'))) return team;

  return DEFAULT_LOGO_URL;
}
